import gql from 'graphql-tag';

export const HomeRecentWorkQuery = gql`
	query HomeRecentWorkQuery(
		$cloudId: ID!
		$first: Int
		$after: String
		$objectTypes: [ActivitiesObjectType!]
	) {
		activities {
			myActivities {
				all(
					filters: [
						{
							type: AND
							arguments: { products: [CONFLUENCE], objectTypes: $objectTypes, cloudIds: [$cloudId] }
						}
					]
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							timestamp
							object {
								id
								events {
									eventType
								}
								content {
									id
									title
									subType
									type
									links {
										webui
										editui
									}
									metadata {
										sourceTemplateEntityId
									}
									space {
										alias
										id
										key
										name
									}
									status
									blank
									emoji: properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
										nodes {
											id
											key
											value
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const HomeRecentWorkV3Query = gql`
	query useHomeRecentWorkDataV3Query(
		$cloudId: ID!
		$first: Int
		$after: String
		$objectTypes: [String!]
	) {
		activity {
			myActivity {
				all(
					filter: {
						type: AND
						rootContainerIds: [$cloudId]
						arguments: { products: ["CONFLUENCE"], objectTypes: $objectTypes }
					}
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							object {
								id
								data {
									... on ConfluencePage {
										id
										title
										type
										subtype
										pageStatus: status
										createdAt
										links {
											webUi
											editUi
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
										space {
											alias
											id
											key
											name
										}
									}
									... on ConfluenceBlogPost {
										id
										title
										type
										blogStatus: status
										createdAt
										links {
											webUi
											editUi
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
										space {
											alias
											id
											key
											name
										}
									}
									... on ConfluenceWhiteboard {
										id
										title
										type
										status
										links {
											webUi
										}
										space {
											alias
											id
											key
											name
										}
									}
									... on ConfluenceDatabase {
										id
										title
										type
										status
										links {
											webUi
										}
										space {
											alias
											id
											key
											name
										}
									}
									... on ConfluenceEmbed {
										id
										title
										type
										status
										links {
											webUi
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
										space {
											alias
											id
											key
											name
										}
									}
								}
							}
							event {
								timestamp
								eventType
							}
						}
					}
				}
			}
		}
	}
`;
